import Controller, { OnBeforeCancel, OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import BaseController from '../../BaseController';
import { TextAPI } from '@philips-internal/oswald-ui-components';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../constants/endpoints';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { SimpleDialog } from '../../dialog-helper';
import { FragmentNames, PhysicianScheduleBlockIndividualEditAliases } from '../../../codegen';
import { Value } from '@philips-internal/oswald-ui-core';
import { ApplicationRoute } from '../../../constants/routes';

@Controller({ component: PhysicianScheduleBlockIndividualEditAliases.PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_LAYOUT, fragment: FragmentNames.PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT })
class PhysicianScheduleBlockIndividualEditController extends BaseController {

  @Inject(PhysicianScheduleBlockIndividualEditAliases.PHYSICIAN_SCHEDULE_BLOCK_DATE_TIME_TEXT)
  scheduleDateTimeTextApi!: TextAPI;

  @OnMount({ target: PhysicianScheduleBlockIndividualEditAliases.PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_FORM })
  handleMount(): void {
    const { scheduleCode, scheduleDateTime, scheduleSequence } = this.historyService.getCurrentRouteParams();
    this.context.set({ scheduleCode, scheduleSequence });

    if (scheduleDateTime) {
      this.scheduleDateTimeTextApi.setValue(scheduleDateTime as string);
    }
  }

  private goBack(): void {
    applicationContext.redirect(ApplicationRoute.PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_LIST);
    applicationContext.clearNavigationStack();
  }

  @OnBeforeSubmit({ target: PhysicianScheduleBlockIndividualEditAliases.PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_FORM })
  handleBeforeSubmitForm(event: SubmitEvent): void {
    const { establishmentCode } = this.historyService.getCurrentRouteParams();
    const body = {
      dayScheduleType: 'N',
      establishmentCode: establishmentCode,
      reasonCode: event.record.description ? event.record.description.reasonNumber : null,
      reasonDescription: event.record.justification ? event.record.justification : null,
      scheduleCode: this.context.get('scheduleCode'),
      scheduleSequence: this.context.get('scheduleSequence'),
      shapeConfSequence: '',
      statusType: 'B',
      userName: '',
    } as Record<string, Value>;

    HttpService.post(Endpoint.POST_PHYSICIAN_SCHEDULE_BLOCK_UNBLOCK_INDIVIDUAL, {}, { body })
      .catch((error) => SimpleDialog.showErrorMessage(error))
      .finally(() => this.goBack())
  }

  @OnBeforeCancel({ target: PhysicianScheduleBlockIndividualEditAliases.PHYSICIAN_SCHEDULE_BLOCK_INDIVIDUAL_EDIT_FORM })
  handleFormBeforeCancel(): void {
    this.goBack();
  }

}

export default PhysicianScheduleBlockIndividualEditController;
